import { HomeRoutes } from "@cheatsheetz/sheetz-home/routes";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 py-6 sm:flex-row sm:justify-between">
        <p className="text-xs text-muted-fg">
          &copy; {new Date().getFullYear()} Cheet.io
        </p>
        <nav className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-muted-fg">
          <Link to={HomeRoutes.About} className="hover:text-fg hover:underline">
            About
          </Link>
          <Link to={HomeRoutes.Privacy} className="hover:text-fg hover:underline">
            Privacy
          </Link>
          <Link to={HomeRoutes.Terms} className="hover:text-fg hover:underline">
            Terms
          </Link>
          <Link to={HomeRoutes.Licenses} className="hover:text-fg hover:underline">
            Licenses
          </Link>
        </nav>
      </div>
    </footer>
  );
}
